module.exports = __webpack_public_path__ + "img/1.e72c0b33.png";